(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquid-ordering"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const status = root.querySelector('[data-status]');
    if (!status) return;
    const messages = root.querySelector('[data-messages]').dataset;
    const form = root.querySelector('[data-request-form]');
    const confirm = root.querySelector('[data-confirm]');
    const review = root.querySelector('[data-review]');
    const lines = root.querySelector('[data-quote-lines]');
    let context, quote, requestId, revision = 0;
    const money = new Intl.NumberFormat('en-CA', {style:'currency',currency:'CAD'});
    const say = key => { status.textContent = messages[key]; };
    let endpoint;
    try {
      endpoint = new URL(root.dataset.endpoint);
      if (endpoint.protocol !== 'https:' || !root.dataset.token) throw new Error('setup');
    } catch { say('setup'); return; }
    async function call(action, payload = {}, url = endpoint.href) {
      const response = await fetch(url, {
        method:'POST',mode:'cors',credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',
        body:new URLSearchParams({payload:JSON.stringify({action,accessToken:root.dataset.token,...payload})}),
        signal:AbortSignal.timeout(40000)
      });
      if (!response.ok) throw new Error('request');
      const data = await response.json();
      if (data.ok !== true) throw new Error('request');
      return data;
    }
    const history = root.querySelector('[data-history]'), historyStatus = root.querySelector('[data-history-status]'), historyRows = root.querySelector('[data-history-rows]'), historyRefresh = root.querySelector('[data-history-refresh]');
    const historyText = key => messages['history'+key[0].toUpperCase()+key.slice(1)];
    const litresText = v => new Intl.NumberFormat('en-CA',{maximumFractionDigits:1}).format(v)+' L';
    const historyDate = value => {
      if (!value) return '—';
      const d=new Date(/^\d{4}-\d{2}-\d{2}$/.test(value)?value+'T12:00:00-05:00':value);
      return Number.isNaN(d.getTime())?'—':new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',year:'numeric',month:'short',day:'numeric'}).format(d);
    };
    const dialog=root.querySelector('[data-order-dialog]'),details=root.querySelector('[data-order-details]');
    let orderOpener;
    const el=(tag,text,className)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(className)n.className=className;return n;};
    const closeDetails=()=>{dialog.close();if(orderOpener?.isConnected)orderOpener.focus();};
    root.querySelector('[data-order-close]').addEventListener('click',closeDetails);
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDetails();});
    dialog.addEventListener('close',()=>{if(orderOpener?.isConnected)orderOpener.focus();});
    function showOrder(order,opener){
      orderOpener=opener;details.replaceChildren();
      root.querySelector('[data-order-title]').textContent=historyText('details')+(order.orderNumber?' #'+order.orderNumber:'');
      const list=el('dl',undefined,'leo-ordering__detail-list');
      const row=(key,value)=>list.append(el('dt',historyText(key)),el('dd',value||historyText('notProvided')));
      row('orderedBy',order.orderedBy);row('orderedOn',order.createdAt?historyDate(order.createdAt):historyText('notRecorded'));
      row('source',historyText(order.source==='manual'?'manual':'online'));
      row('product',(order.products||[]).map(p=>p.product+' · '+litresText(p.litres)).join('\n'));
      if(order.toteCount)row('totes',String(order.toteCount));
      row('location',(order.locations||[]).map(s=>[s.name,s.address].filter(Boolean).join('\n')).join('\n\n'));
      const fulfilmentKeys={'Bulk delivery':'bulkDelivery','Customer pickup':'customerPickup','Delivery quote requested':'deliveryQuote','Confirm with Liquids Revolution':'confirmFulfilment'};
      row('fulfilment',historyText(fulfilmentKeys[order.fulfilment]||'confirmFulfilment'));
      row('requested',order.requestedDate?historyDate(order.requestedDate):'');
      row('po',order.purchaseOrder);row('notes',order.notes);
      row('scheduled',order.scheduledDates.length?order.scheduledDates.map(historyDate).join('\n'):historyText('unscheduled'));
      details.append(list,el('h3',historyText('delivered')));
      if(order.deliveries.length){
        const events=el('ul',undefined,'leo-ordering__detail-events');
        order.deliveries.forEach(event=>events.append(el('li',[
          event.pickup?historyText('pickup'):historyText('delivery'),historyDate(event.date),event.product,litresText(event.litres),event.location?.name
        ].filter(Boolean).join(' · '))));
        details.append(events);
        if(order.deliveries.reduce((sum,e)=>sum+e.litres,0)<order.litres)details.append(el('p',historyText('partial'),'leo-ordering__muted'));
      }else details.append(el('p',historyText('pending'),'leo-ordering__muted'));
      dialog.showModal();
    }
    async function loadHistory() {
      if(historyRefresh.disabled)return;
      history.hidden=false;historyRefresh.disabled=true;historyStatus.textContent=historyText('loading');
      root.querySelector('[data-history-table]').hidden=true;historyRows.replaceChildren();
      try {
        const historyEndpoint=new URL(root.dataset.historyEndpoint);
        if(historyEndpoint.protocol!=='https:')throw Error('history setup');
        const data=await call('history_v2',{},historyEndpoint.href);
        if(!Array.isArray(data.orders))throw Error('history');
        data.orders.forEach(order=>{
          const tr=document.createElement('tr');
          const cell=text=>{const td=document.createElement('td');td.textContent=text;tr.append(td);return td;};
          const first=cell(''),button=el('button',order.orderNumber?'#'+order.orderNumber:historyText('received'),'leo-ordering__order-link');
          button.type='button';button.setAttribute('aria-haspopup','dialog');button.addEventListener('click',()=>showOrder(order,button));first.append(button);
          if(order.createdAt)first.append(el('small',historyDate(order.createdAt),'leo-ordering__order-date'));
          cell(order.product);
          cell(litresText(order.litres)+(order.toteCount?' · '+order.toteCount+' '+historyText('totes'):''));
          cell(order.scheduledDates.length?order.scheduledDates.map(historyDate).join(' / '):historyText('unscheduled'));
          const events=cell(order.deliveries.length?'':'—');
          order.deliveries.forEach(event=>{const p=document.createElement('p');p.textContent=(event.pickup?historyText('pickup'):historyText('delivery'))+' '+historyDate(event.date)+' · '+litresText(event.litres);events.append(p);});
          historyRows.append(tr);
        });
        root.querySelector('[data-history-table]').hidden=!data.orders.length;
        historyStatus.textContent=!data.orders.length?historyText('empty'):data.hasMore?historyText('more'):'';
      } catch {historyRows.replaceChildren();root.querySelector('[data-history-table]').hidden=true;historyStatus.textContent=historyText('error');}
      finally {historyRefresh.disabled=false;}
    }
    historyRefresh.addEventListener('click',loadHistory);
    function clearQuote() {
      revision++; quote = null; requestId = null; confirm.hidden = true; lines.replaceChildren();
      root.querySelector('[data-summary-intro]').hidden = false;
    }
    function addLine(label, value) {
      const dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = label; dd.textContent = money.format(value); lines.append(dt,dd);
    }
    function selection() {
      const values = Object.fromEntries(new FormData(form));
      values.deliveryRequested=values.orderFormat==='Totes'&&form.elements.deliveryRequested.checked;
      values.toteCount = values.orderFormat==='Totes'?Number(values.toteCount):0;
      values.litres = values.orderFormat==='Totes'?values.toteCount*1000:Number(values.litres);
      if(values.orderFormat==='Totes'&&(!Number.isSafeInteger(values.toteCount)||values.toteCount<1||values.toteCount>1000))throw new Error('totes');
      if (!Number.isSafeInteger(values.litres) || values.litres < 1 || values.litres > 1000000) throw new Error('volume');
      return values;
    }
    function updateTotes() {
      const tote=form.elements.orderFormat.value==='Totes',count=Number(form.elements.toteCount.value);
      root.querySelector('[data-tote-count]').hidden=!tote;
      root.querySelector('[data-tote-delivery]').hidden=!tote;
      const freightNote=root.querySelector('[data-freight-note]');freightNote.hidden=!tote;freightNote.textContent=form.elements.deliveryRequested.checked?messages.deliveryNote:messages.pickupNote;
      root.querySelector('[data-tote-summary]').hidden=!tote;
      root.querySelector('[data-bulk-litres]').hidden=tote;
      form.elements.toteCount.required=tote;form.elements.litres.required=!tote;
      root.querySelector('[data-tote-summary]').textContent=messages.toteSummary.replace('[litres]',(Number.isSafeInteger(count)&&count>0?count*1000:0).toLocaleString('en-CA')).replace('[deposit]',money.format(Number.isSafeInteger(count)&&count>0?count*75:0));
    }
    function updateProducts() {
      const previous=form.elements.productId.value;
      form.elements.productId.replaceChildren();
      context.products.filter(p=>(p.orderFormats||['Bulk']).includes(form.elements.orderFormat.value)).forEach(p=>form.elements.productId.add(new Option(p.name,p.id)));
      if([...form.elements.productId.options].some(p=>p.value===previous))form.elements.productId.value=previous;
    }
    form.addEventListener('input', () => {clearQuote();updateTotes();});
    form.addEventListener('change', event => {
      clearQuote();if(event.target===form.elements.orderFormat)updateProducts();updateTotes();
      const product = context.products.find(p=>p.id===form.elements.productId.value);
      const detail = root.querySelector('[data-product-detail]');
      detail.textContent = product ? `${product.pricingLabel} · ${messages.rate} ${product.ratePerL.toLocaleString('en-CA',{style:'currency',currency:'CAD',minimumFractionDigits:2,maximumFractionDigits:4})}/L` : '';
    });
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (!form.reportValidity()) return;
      clearQuote(); const requestedRevision = revision; review.disabled = true; say('reviewing');
      try {
        const data = await call('quote',selection());
        if (requestedRevision !== revision) {say('updated');return;}
        const q = data.quote;if(q&&q.toteDepositAmount===undefined)q.toteDepositAmount=0;
        if (!q || !q.id || !q.expiresAt || Date.parse(q.expiresAt) <= Date.now() || ![q.productAmount,q.prebuyCredit,q.deliveryAmount,q.toteDepositAmount,q.totalBeforeTax].every(Number.isFinite)) throw new Error('quote');
        if (q.productAmount < 0 || q.prebuyCredit < 0 || q.prebuyCredit > q.productAmount || q.deliveryAmount < 0 || q.toteDepositAmount < 0 || Math.abs(q.productAmount-q.prebuyCredit+q.deliveryAmount+q.toteDepositAmount-q.totalBeforeTax) > .011) throw new Error('totals');
        quote = q; requestId = crypto.randomUUID();
        addLine(messages.product,q.productAmount);addLine(messages.credit,-q.prebuyCredit);if(form.elements.orderFormat.value!=='Totes')addLine(messages.delivery,q.deliveryAmount);if(q.toteDepositAmount>0)addLine(messages.toteDeposit,q.toteDepositAmount);addLine(messages.total,q.totalBeforeTax);
        root.querySelector('[data-summary-intro]').hidden = true;confirm.hidden = false;say('quoted');
      } catch { say('error'); } finally { review.disabled = false; }
    });
    confirm.addEventListener('click', async () => {
      if (!quote || Date.parse(quote.expiresAt) <= Date.now()) {clearQuote();say('updated');return;}
      confirm.disabled = true;review.disabled = true;form.querySelectorAll('input,select,textarea').forEach(el=>{el.disabled=true;});say('sending');
      try {
        const submission = {quoteId:quote.id,requestId};
        let data;
        try { data = await call('submit',submission); }
        catch { data = await call('submit',submission); }
        if (!data.request || !data.request.id || !['Needs review','Approved','Scheduled'].includes(data.request.status)) throw new Error('receipt');
        status.textContent = `${messages.received} ${data.request.reference || data.request.id}`;
        status.scrollIntoView?.({behavior:'smooth',block:'center'});
        form.querySelectorAll('input,select,textarea,button').forEach(el=>{el.disabled=true;});
        confirm.hidden = true;quote = null;loadHistory();
      } catch {say('error');confirm.disabled=false;review.disabled=false;form.querySelectorAll('input,select,textarea').forEach(el=>{el.disabled=false;});}
    });
    call('context').then(data => {
      if (!Array.isArray(data.products) || !Array.isArray(data.shipTos)) throw new Error('context');
      context = data;loadHistory();
      if (!context.products.length || !context.shipTos.length) {say('empty');return;}
      context.products.forEach(p => {if (!p.id || !p.name || !Number.isFinite(p.ratePerL) || p.ratePerL < 0) throw new Error('product');});
      [...form.elements.orderFormat.options].forEach(o=>{if(!(context.orderFormats||['Bulk']).includes(o.value))o.remove();});
      root.querySelector('[data-format-label]').hidden=form.elements.orderFormat.options.length<2;
      updateProducts();updateTotes();
      context.shipTos.forEach(s => {if (!s.id || !s.label) throw new Error('location');form.elements.shipToId.add(new Option(s.label,s.id));});
      const today = new Date();today.setMinutes(today.getMinutes()-today.getTimezoneOffset());form.elements.requestedDate.min=today.toISOString().slice(0,10);
      root.querySelector('[data-workspace]').hidden=false;form.dispatchEvent(new Event('change'));say('ready');
    }).catch(()=>say('error'));
  }
  document.querySelectorAll('[data-leo-ordering]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-leo-ordering]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
